import { render, staticRenderFns } from "./DeliveryWarehouseAddForm.vue?vue&type=template&id=96d7f3f2&"
import script from "./DeliveryWarehouseAddForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryWarehouseAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports